import { ChevronDown } from 'lucide-react'
import IndicatorConfigModal from '@/components/Indicators/IndicatorConfigModal'
import ToggleField from '@/components/Indicators/ToggleField'

function Section({ title, children, sectionKey, config, onChange }) {
  const open = config?.panelSections?.[sectionKey] ?? false
  const toggle = () => onChange({ ...config, panelSections: { ...(config.panelSections || {}), [sectionKey]: !open } })
  return (
    <div className="border border-[var(--hair,rgba(176,141,87,0.35))] rounded-lg overflow-hidden">
      <button
        onClick={toggle}
        className="w-full flex items-center justify-between px-2.5 py-2 bg-[var(--paper,#FDFDFA)] hover:bg-black/[0.02] transition-colors"
      >
        <span className="text-xs font-semibold uppercase tracking-wider text-[var(--gold,#B08D57)]">{title}</span>
        <ChevronDown size={14} className={`text-[var(--ink-soft,#4A5A52)] transition-transform ${open ? '' : '-rotate-90'}`} />
      </button>
      {open && (
        <div className="px-2.5 py-2 space-y-2 bg-white/50 dark:bg-gray-900/20">
          {children}
        </div>
      )}
    </div>
  )
}

// Canon v1.0: la lógica de detección es fija (la aplica el backend); el panel
// solo expone los dos toggles visuales y el del dashboard. Sin parámetros
// numéricos, sin colores, sin botón de reset (no hay nada visual que resetear).
export default function LiquidityPoolsQuantumPanel({ config, onChange, onClose }) {
  const cfg = config || {}

  const update = (key, value) => onChange({ ...cfg, [key]: value })

  return (
    <IndicatorConfigModal title="Configuración Liquidity Pools Quantum" isOpen onClose={onClose}>
      <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-1">

        <Section title="Visualización" sectionKey="visibility" config={cfg} onChange={onChange}>
          <ToggleField label="Pools de liquidez (zonas)" value={cfg.showPools ?? true} onChange={(v) => update('showPools', v)} />
          <ToggleField label="CISD (triángulos)" value={cfg.showCisd ?? true} onChange={(v) => update('showCisd', v)} />
          <ToggleField label="Mostrar dashboard" value={cfg.showDashboard ?? true} onChange={(v) => update('showDashboard', v)} />
        </Section>

      </div>
    </IndicatorConfigModal>
  )
}
